/* eslint-disable no-return-assign */
import format from '_shared_/plugins/format';

const properties = [
  'contextAcronym',
  'contextAssetType',
  'contextInvestmentStrategyName',
  'contextObjective',
  'contextPreviousName',
  'contextPublishableStrategyName',
  'contextStartDate',
  'contextInceptionDate'
];

const mutations = {
  SET_CONTEXT(state, payload) {
    state.contextAcronym = payload.Acronym;
    state.contextAssetType = payload.AssetType;
    state.contextInvestmentStrategyName = payload.InvestmentStrategyName;
    state.contextObjective = payload.Objective;
    state.contextPreviousName = payload.PreviousName;
    state.contextPublishableStrategyName = payload.PublishableStrategyName;
    state.contextStartDate = format.formatHelpers.shortDate(payload.StartDate, true);
    state.contextInceptionDate = format.formatHelpers.shortDate(payload.InceptionDate, true);

    if (state.contextObjective.indexOf(' ') > -1) {
      state.contextObjective = state.contextObjective.split(' ').join('-');
    }
  }
};

const getters = {
  contextAcronym: state => state.contextAcronym,
  contextAssetType: state => state.contextAssetType,
  contextInvestmentStrategyName: state => state.contextInvestmentStrategyName,
  contextObjective: state => state.contextObjective,
  contextPreviousName: state => state.contextPreviousName,
  contextPublishableStrategyName: state => state.contextPublishableStrategyName,
  contextStartDate: state => state.contextStartDate,
  contextInceptionDate: state => state.contextInceptionDate
};

const state = {};
properties.forEach(property => state[property] = '');

export default {
  state,
  getters,
  mutations
};
